import PropTypes                 from 'prop-types';
import React, { useState }       from 'react';
import TextField                 from '@material-ui/core/TextField';
import { Trans, useTranslation } from 'react-i18next';
import InputAdornment            from '@material-ui/core/InputAdornment';
import CircularProgress          from '@material-ui/core/CircularProgress';
import Grid                      from '@material-ui/core/Grid';
import Alert                     from '@material-ui/lab/Alert';
import HelpOutlineIcon           from '@material-ui/icons/HelpOutline';
import Tooltip                   from '@material-ui/core/Tooltip';
import Card from '@material-ui/core/Card';
import {CardHeader, Typography} from '@material-ui/core';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import CardContent from '@material-ui/core/CardContent';
import {blue, green, orange} from '@material-ui/core/colors';
import {useRest} from '@karpeleslab/react-klbfw-hooks';
import {formatBalance, formatPayoutMethod} from '../../../utils/misc';
import CodeIcon from '@material-ui/icons/Code';
import PaymentIcon from '@material-ui/icons/Payment';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import AffiliateStripe from './AffiliateStripe';
const Affiliate = ({ affiliate }) => {
	const { t } = useTranslation();
	const [total] = useRest('Order/Affiliate:getTotal', {
		Affiliate__: affiliate.Affiliate__,
		Affiliate_Status: 'waiting'
	});
	const [referral, setReferral] = useState('');

	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<Alert severity='info'>{t(`partnership_rate_${affiliate.Type.toLowerCase()}`)}</Alert>
			</Grid>
			<Grid item xs={12}>
				<Grid container spacing={3}>
					<Grid item xs={12} md={3}>
						<Card>
							<CardHeader
								avatar={<AttachMoneyIcon fontSize="large" style={{ color: green[500] }}/>}
								action={
									<Tooltip
										arrow
										title={
											<Trans i18nKey='current_balance_helperText'>
												sample<br/>
												<strong>sample</strong>
											</Trans>
										}
										placement='top'
									>
										<HelpOutlineIcon/>
									</Tooltip>
								}
								title={t('current_balance')}
							/>

							<CardContent>
								{!total && <CircularProgress/>}
								{total && <Typography color="textPrimary" component="p" align='center' variant='h5'>
									<Trans i18nKey='balance' values={{balance:formatBalance(affiliate.Balance_USD), waiting:(total.data.total.display ?? '$0')}}>
										sample<br/>
										<strong>sample</strong>
									</Trans>
								</Typography>}

							</CardContent>
						</Card>
					</Grid>
					<Grid item xs={12} md={3}>
						<Card>
							<CardHeader
								avatar={<MonetizationOnIcon fontSize="large" style={{ color: green[500] }}/>}
								title={t('total_earning')}
								action={
									<Tooltip
										arrow
										title={
											<Trans i18nKey='total_earning_helper'>
												sample<br/>
												<strong>sample</strong>
											</Trans>
										}
										placement='top'
									>
										<HelpOutlineIcon/>
									</Tooltip>
								}
							/>
							<CardContent>
								<Typography color="textPrimary" component="p" align='center' variant='h5'>
									<strong>${(affiliate.Cumul_USD)}</strong>
								</Typography>
							</CardContent>
						</Card>
					</Grid>
					<Grid item xs={12} md={3}>
						<Card>
							<CardHeader
								avatar={<CodeIcon fontSize="large" style={{ color: blue[500] }}/>}
								title={t('affiliate_code')}
							/>

							<CardContent>
								<Typography color="textPrimary" component="p" align='center' variant='h5'>
									<Trans i18nKey='affiliate_code_text' values={{code:affiliate.Code, level:t(affiliate.Type)}}>
										sample<br/>
										<strong>sample</strong>
									</Trans>
								</Typography>

							</CardContent>
						</Card>
					</Grid>
					<Grid item xs={12} md={3}>
						<Card>
							<CardHeader
								avatar={<PaymentIcon fontSize="large" style={{ color: orange[500] }}/>}
								title={t('payout_method') + ':' + formatPayoutMethod(affiliate.Payout_Method)}
							/>

							<CardContent>
								<AffiliateStripe affiliate={affiliate}/>
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</Grid>
			<Grid item xs={12} md={8}>
				<TextField
					label={t('account_affiliate_link_lbl')}
					helperText={t('account_affiliate_link_helperText')}
					autoFocus
					value={
						`${process.env.REACT_APP_SHELL_URL}/?_a=${affiliate.Code}${referral.trim() ? `&_b=${encodeURIComponent(referral.trim())}` : ''}`
					}
					variant='outlined'
					editable='false'
					fullWidth
					InputProps={!affiliate ?
						{
							endAdornment:
								(<InputAdornment position='end'>
									<CircularProgress thickness={1}/>
								</InputAdornment>)
						} : undefined
					}
				/>
			</Grid>
			<Grid item xs={12} md={4}>
				<TextField
					label={t('account_affiliate_surfer_label')}
					value={referral}
					onChange={e => setReferral(e.target.value)}
					variant='outlined'
					fullWidth
					inputProps={{
						maxLength: 64,
					}}
					InputProps={
						{
							endAdornment:
								(<InputAdornment position='end'>
									<Tooltip
										arrow
										title={
											<Trans i18nKey='account_affiliate_surfer_helperText'>
												sample<br/>
												<strong>sample</strong>
											</Trans>
										}
										placement='top'
									>
										<HelpOutlineIcon/>
									</Tooltip>
								</InputAdornment>)
						}
					}
				/>
			</Grid>
		</Grid>
	);
};

export default Affiliate;

Affiliate.propTypes = {
	affiliate: PropTypes.object.isRequired
};
